import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import FinalScore from "../finalScore/FinalScore";
import Answers from "../answers/Answers";
import { useLocation } from "react-router-dom";
import resultError from "../../images/resultError.jpeg"; 
import useExamScoreStyle from "./examScoreStyle";

function ExamScore() {
  const classes = useExamScoreStyle();
  const location = useLocation();

  // const examResultData = JSON.parse(location.state?.examResult);

  let examResultData;
  try {
    examResultData = location.state?.examResult
  } catch (error) {
    console.error("Error parsing examResultData:", error);
  }

  
  const [instantResultState, setInstantResultState] = useState(sessionStorage.getItem("examInstantResult"));

  // const examResultData = JSON.parse(sessionStorage.getItem("examResult"));


  useEffect(() => {
  if(sessionStorage.getItem('userId')==='4660'){
    setInstantResultState('with_answer');
  }else{
    setInstantResultState(sessionStorage.getItem("examInstantResult"));
  }
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.headingMain}>
        <Typography variant="h3">Exam Score!</Typography>
      </div>


      {/* {examResultData && examResultData.summary && <FinalScore examResultData={examResultData} />}
      {instantResultState === "with_answer" && examResultData && examResultData.summary && examResultData.result && <Answers examResultData={examResultData} />} */}


      {examResultData && examResultData.summary ? (
      <>
        <FinalScore examResultData={examResultData} />
        {examResultData.result && instantResultState === "with_answer" && <Answers examResultData={examResultData} />}
      </>
    ) : (
      <div>

        <Typography variant="body1">Result With Answers data not available for now.</Typography>
        <img src={resultError} alt="Result Error" />

      </div>
    )}

    </div>
  );
}

export default ExamScore;
